module.exports = __webpack_public_path__ + "957458bb5e5acc85933aab47bb9393cf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/samsung_gear_connect/img-app@2x.png
// module id = 1838
// module chunks = 1